<template>
  <div v-if="isEnabled" class="slot" v-bind="$attrs">
    <component v-for="item in items" :key="item.source" :is="Components[item.type]" :value="item" />
  </div>
</template>

<script>
import fetch from '@/fetch'
import { ObjectToDotNotation } from '@/utils'
import Components from './Components'

export default {
  props: {
    placement: {
      type: String,
      required: true,
    },
    query: Object,
  },
  data() {
    return {
      promise: null,
      items: [],
      Components,
    }
  },
  computed: {
    isEnabled() {
      return Boolean(this.items.length)
    },
    qs() {
      let p = new URLSearchParams()
      Object.entries(ObjectToDotNotation(this.query || {})).forEach(([key, value]) => {
        if (value === undefined) return
        if (value instanceof Array) return value.forEach(v => p.append(key, v))
        return p.append(key, value)
      })
      return p.toString()
    },
  },
  methods: {
    fetch() {
      this.promise = fetch(`/api/slot/${this.placement}?${this.qs}`, { headers: { 'Cache-Control': 'nocache' } })
        .then(res => res.json())
        .then(items => (this.items = items))
    },
  },
  created() {
    this.fetch()

    this.$bus.$on('slot:refetch', placement => {
      if (placement && this.placement !== placement) return
      this.fetch()
    })
  },
}
</script>
